import { mergeAttributes } from '@tiptap/core';
import TiptapLink from '@tiptap/extension-link';
import { Plugin } from '@tiptap/pm/state';

const Link = TiptapLink.extend({
  inclusive: false,

  addAttributes() {
    return {
      ...this.parent?.(),
      href: {
        default: null,
        parseHTML: (element) => {
          const href = element.getAttribute('href');
          return href;
        },
        renderHTML: (attributes) => {
          let { href } = attributes;
          if (href && !/^https?:\/\//i.test(href)) {
            href = `https://${href}`;
          }

          return {
            href,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])',
        getAttrs: (element) => {
          // check if link starts with javascript:
          const href = element.getAttribute('href')?.toLowerCase();
          if (href && href.trim().startsWith('javascript')) {
            return false;
          }
          return null;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const href = HTMLAttributes.href?.trim().toLowerCase();
    const safeHref = /^javascript\s*:/i.test(href) ? '' : href;

    return [
      'a',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        href: safeHref,
        class: 'link',
      }),
      0,
    ];
  },

  addProseMirrorPlugins() {
    const { editor } = this;

    return [
      ...(this.parent?.() || []),
      new Plugin({
        props: {
          handleKeyDown: (view, event) => {
            const { selection } = editor.state;

            if (event.key === 'Escape' && !selection.empty) {
              editor.commands.focus(selection.to, { scrollIntoView: false });
            }

            return false;
          },
        },
      }),
    ];
  },
});

export default Link;
